import { LoginInfoDto } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { useStore } from '../../store';
import { HttpError } from '../../utils/errors';
import {
  getPublicApiHeaders,
  portalGatewayClient,
} from '../portalGatewayClient';

export const getTenantLoginInfo: QueryFunction<LoginInfoDto> = async () => {
  const res = await portalGatewayClient.publicApi.getLoginInfo({
    headers: getPublicApiHeaders(),
  });
  if (res.ok) {
    return res.data.data;
  }
  throw new HttpError('Fetching tenant login info failed.', res.status);
};

export function useLoginInfoQuery() {
  const tenantName = useStore((state) => state.tenantName);

  return useQuery({
    queryKey: ['tenantLoginInfo'],
    queryFn: getTenantLoginInfo,
    enabled: tenantName != null,
    notifyOnChangeProps: ['data', 'error'],
  });
}
